import { Home, Building2, Factory, ArrowRight, Check } from "lucide-react";
import { requestLead } from "@/lib/leadIntent";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

const PROGRAMS = [
  {
    id: "home",
    icon: Home,
    brand: "SEJUKARA HOME",
    subtitle: "Untuk Rumah & Properti",
    services: ["Service AC", "Cleaning", "Inspection", "Installation", "Home Care"],
    cta: "BOOKING SERVICE",
    intent: { audience: "b2c", kebutuhan: "Service" },
    event: EVENTS.BOOKING_SERVICE,
  },
  {
    id: "care",
    icon: Building2,
    brand: "SEJUKARA CARE",
    subtitle: "Untuk Bisnis & Perusahaan",
    services: [
      "Preventive Maintenance",
      "Corrective Maintenance",
      "Maintenance Contract",
      "Maintenance Schedule",
      "Service Report",
    ],
    cta: "REQUEST MAINTENANCE",
    intent: { audience: "b2b", kebutuhan: "Preventive Maintenance" },
    event: EVENTS.REQUEST_MAINTENANCE_CONTRACT,
    featured: true,
  },
  {
    id: "hvac",
    icon: Factory,
    brand: "SEJUKARA HVAC",
    subtitle: "Untuk Commercial & Industrial",
    services: ["HVAC", "Ducting", "VRF / VRV", "AHU / FCU", "HVAC Maintenance"],
    cta: "REQUEST HVAC ASSESSMENT",
    intent: { audience: "commercial", kebutuhan: "Maintenance HVAC" },
    event: EVENTS.REQUEST_HVAC_ASSESSMENT,
  },
];

export const ServicePrograms = () => {
  return (
    <section
      id="programs"
      data-testid="programs-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          kicker="Program SEJUKARA"
          title="Temukan Solusi SEJUKARA"
          description="Tiga program layanan yang disesuaikan dengan kebutuhan Anda — rumah, bisnis, hingga fasilitas commercial & industrial."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {PROGRAMS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.id} delay={i * 0.1}>
                <article
                  data-testid={`program-card-${p.id}`}
                  className={`flex h-full flex-col rounded-2xl p-7 transition-all duration-300 ${
                    p.featured
                      ? "bg-[#0F172A] ring-2 ring-[#E0A400]"
                      : "border border-slate-200 bg-white hover:-translate-y-1 hover:shadow-[0_18px_40px_-16px_rgba(15,23,42,0.18)]"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span
                      className={`flex h-12 w-12 items-center justify-center rounded-xl ${
                        p.featured ? "bg-[#E0A400] text-[#0F172A]" : "bg-[#0F172A] text-white"
                      }`}
                    >
                      <Icon className="h-6 w-6" />
                    </span>
                    {p.featured && (
                      <span className="rounded-full bg-[#E0A400]/15 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-[#E0A400]">
                        Populer B2B
                      </span>
                    )}
                  </div>

                  <h3 className={`mt-6 text-xl font-extrabold tracking-tight ${p.featured ? "text-white" : "text-slate-900"}`}>
                    {p.brand}
                  </h3>
                  <p className={`mt-1 text-sm font-semibold ${p.featured ? "text-[#E0A400]" : "text-slate-500"}`}>
                    {p.subtitle}
                  </p>

                  <ul className="mt-6 flex-1 space-y-2.5">
                    {p.services.map((s) => (
                      <li key={s} className={`flex items-center gap-2.5 text-[15px] ${p.featured ? "text-slate-200" : "text-slate-700"}`}>
                        <Check className={`h-4 w-4 flex-none ${p.featured ? "text-[#E0A400]" : "text-[#25D366]"}`} />
                        {s}
                      </li>
                    ))}
                  </ul>

                  <button
                    type="button"
                    onClick={() => {
                      trackEvent(p.event, { source: `program_${p.id}` });
                      requestLead(p.intent);
                    }}
                    data-testid={`program-cta-${p.id}`}
                    className={`group mt-7 inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3.5 text-sm font-bold transition-colors ${
                      p.featured
                        ? "bg-[#E0A400] text-[#0F172A] hover:bg-[#c9930a]"
                        : "bg-[#25D366] text-white hover:bg-[#1eb85a]"
                    }`}
                  >
                    {p.cta}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </button>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicePrograms;
